import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot} from '@angular/router';
import {Observable, of} from 'rxjs';
import {catchError, mergeMap} from 'rxjs/operators';
import {LoanService} from '../../service/loan/loan.service';
import {ErrorService} from '../../error/error.service';
import {StateTransitionsCustomerService} from '../../helper/stateTransitions/state-transitions.customer.service';

@Injectable({
  providedIn: 'root'
})
export class LoanApplicationCustomerResolverService implements Resolve<any> {

  constructor(
    private loanService: LoanService,
    private errorService: ErrorService,
    private state: StateTransitionsCustomerService,
    public route: Router
  ) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.loanService.loanDetails(route.params.id).pipe(
      mergeMap((res: any) => {
        let allowed = this.state.isRequestedRouteAllowed(route.component, res.data);
        if (!allowed) {
          let allowedRoute = this.state.findAllowedRoute(res.data);
          let navigateToLink: string;
          if (allowedRoute !== null) {
            navigateToLink = `/loan/process/${route.params.id}${allowedRoute}`;
          } else {
            navigateToLink = '/error';
          }
          this.route.navigateByUrl(navigateToLink);
          return Observable.empty();
        }
        return of({...res.data, token: route.params.id});
      }),
      catchError((err) => {
        this.errorService.errorHandlerOnGetDetailOfLoan(err);
        return Observable.empty();
      })
    );
  }
}
